export default function Arrows({ currentPage, hasMore, fetchNext, prevPage }) {
    return (
        <div className="invoice-init-right__right">
            {currentPage > 1 && (
                <div
                    className="invoice-init-right__arrrow-left"
                    onClick={prevPage}
                    style={{ cursor: "pointer" }}
                >
                    {"<"}
                </div>
            )}

            <div className="invoice-init-right__page-number">
                {currentPage}
            </div>

            {hasMore && (
                <div
                    className="invoice-init-right__arrrow-right"
                    onClick={fetchNext}
                    style={{ cursor: "pointer" }}
                >
                    {">"}
                </div>
            )}
        </div>
    );
}
